const React = require('react');
const PropTypes = require('prop-types');
const ChevronLeft16 = require('@andes/icons/ChevronLeft16');
const ChevronRight16 = require('@andes/icons/ChevronRight16');
const { Link } = require('frontend-spa');

function NextStepCards(props) {
  const { title, description, link, type, isPrevious } = props;

  return (
    <div className="next-step-card">

      <div className="next-step-card-container">
        {isPrevious && (
          <div className="next-step-card-chevron-prev">
            <ChevronLeft16 className="chevron-size-prev" />
          </div>
        )}

        <div className="next-step-card-title-container ">
          <Link
            to={link}
            onClick={() => { window.scroll(0, 0); }}
          >
            <div className="next-step-card-title" id="next-step-card-title"> {type} </div>
            <div className="next-step-title"> {title} </div>
            <div className="next-step-card-text"> {description} </div>
          </Link>
        </div>

        {!isPrevious && (
          <div className="next-step-card-chevron">
            <ChevronRight16 className="chevron-size" />
          </div>
        )}
      </div>

      <div id="feedback-container" className="feedback-container" />

    </div>
  );
}

NextStepCards.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    isPrevious: PropTypes.bool.isRequired,
  }).isRequired,
};

module.exports = NextStepCards;
